import { makeStyles, Theme } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme: Theme) => ({
  textField: {
    marginTop: "10px",
  },
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  toolBar: {
    //   maxWidth: 800,
    width: "100%",
    height: "100%",
    flex: 1,
  },
  barContainer: {
    display: "flex",
    //   justifyContent:'space-between',
    height: "60px",
    paddingRight: "10px",
  },
  buttonGroup: {
    height: "100%",
    display: "flex",
    alignItems: "center",
  },
  errButton: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    border: "1px solid red",
  },
  facemContainer: {
    height: "60px",
    display: "flex",
    alignItems: "center",
    marginRight: "0.5em",
  },
  facemField: {
    background: "#fac61b",
  },
  tabOne: {
    backgroundColor: "#005992",
    width: "400px",
    minWidth: "400px",
    color: "#fff",
  },
  locationButton: {
    backgroundColor: "#1377c9",
    marginLeft: "1rem",
    height: "46px",
    borderRadius: 0,
    color: "#fff",
    "&:hover": {
      backgroundColor: "#1377c9",
    },
  },
  outlinedInput: {
    border: "1px solid red",
    "&.Mui-focused": {
      border: "none",
    },
  },
}));
